var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon24PxFolderOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.2986V4.76021C3 4.39298 3.14588 4.0408 3.40554 3.78113C3.66521 3.52147 4.01739 3.37559 4.38462 3.37559H9.49385C9.81013 3.36637 10.1201 3.46577 10.372 3.65724C10.6239 3.8487 10.8027 4.12068 10.8785 4.4279L11.3077 6.14482H19.6154C19.9826 6.14482 20.3348 6.29069 20.5944 6.55036C20.8541 6.81003 21 7.16221 21 7.52944V19.2986C21 19.666 20.8541 20.0181 20.5944 20.2777C20.3348 20.5374 19.9826 20.6832 19.6154 20.6832H4.38462C4.01739 20.6832 3.66521 20.5374 3.40554 20.2777C3.14588 20.0181 3 19.666 3 19.2986Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24PxFolderOutline);
export default __webpack_public_path__ + "static/media/icon_24px_folder_outline.61e1a764293a4343b61cfa5de765e4a1.svg";
export { ForwardRef as ReactComponent };